<template>
	<v-speed-dial
		v-model="fab"
		class="speed-dial"
		direction="top"
		transition="slide-y-reverse-transition"
		z-index="99"
		fixed
		bottom
		right
	>
		<v-btn slot="activator" v-model="fab" v-blur fab>
			<v-icon
				class="speed-dial--activator"
				:class="{ active: fab }"
				color="rust-red"
				>fa-plus</v-icon
			>
		</v-btn>

		<v-list elevation="1" class="fab-list">
			<v-subheader inset @click.stop>Wizards</v-subheader>
			<v-list-item
				v-for="wizard in wizards"
				:key="wizard"
				@click="$emit('action:wizard', wizard)"
			>
				<v-list-item-icon>
					<v-icon size="20">fas fa-robot</v-icon>
				</v-list-item-icon>
				<v-list-item-content>
					<v-list-item-title
						v-text="strings.wizards.add[wizard]"
					></v-list-item-title>
				</v-list-item-content>
			</v-list-item>

			<template v-if="showAddScene">
				<v-divider />

				<v-list-item @click="$emit('action:add-scene')">
					<v-list-item-icon>
						<v-icon size="24">fas fa-chess</v-icon>
					</v-list-item-icon>
					<v-list-item-content>
						<v-list-item-title v-text="strings.wizards.add.manual" />
					</v-list-item-content>
				</v-list-item>
			</template>
		</v-list>
	</v-speed-dial>
</template>

<style lang="scss" scoped>
.speed-dial {
	.speed-dial--activator {
		transition: transform 150ms ease;

		&.active {
			transform: rotate(135deg);
		}
	}

	::v-deep.v-speed-dial__list {
		right: 0;
		left: unset;
		width: fit-content;

		.v-subheader {
			height: 32px;
		}

		.v-list-item {
			height: 40px;
		}
	}
}
</style>

<script>
import strings from "@/utils/strings";
import { mapGetters } from "vuex";

export default {
	props: {
		showAddScene: { type: Boolean, default: false },
	},

	data: () => ({
		strings: strings.live.scenes,

		// Showing fab speed-dial
		fab: false,
	}),

	computed: {
		...mapGetters({ wizards: "scenes/availableWizards" }),
	},
};
</script>
